(function() {
  'use strict';

  function initializeCarousels(retryCount = 0) {
    const maxRetries = 50;
    
    if (typeof Swiper === 'undefined') {
      if (retryCount < maxRetries) {
        setTimeout(function() {
          initializeCarousels(retryCount + 1);
        }, 100);
        return;
      } else {
        const allCarousels = document.querySelectorAll('.main-swiper, .solutions-carousel, .articles-slider');
        allCarousels.forEach(function(carousel) {
          carousel.style.visibility = 'visible';
        });
        return;
      }
    }

    const mainSwiperElement = document.querySelector('.main-swiper');
    if (mainSwiperElement) {
      mainSwiperElement.style.visibility = 'hidden';
      
      const swiper = new Swiper('.main-swiper', {
        spaceBetween: 10,
        grabCursor: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
        },
        on: {
          init: function() {
            mainSwiperElement.style.visibility = 'visible';
          }
        }
      });
    }

    const solutionsCarouselElement = document.querySelector('.solutions-carousel');
    if (solutionsCarouselElement) {
      solutionsCarouselElement.style.visibility = 'hidden';
      const slideCount = solutionsCarouselElement.querySelectorAll('.swiper-slide').length;
      
      try {
        const solutionsSwiper = new Swiper('.solutions-carousel', {
          spaceBetween: 20,
          slidesPerView: 'auto',
          loop: slideCount > 4,
          centeredSlides: false,
          grabCursor: true,
          autoplay: {
            delay: 2500,
            disableOnInteraction: false
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
            hide: false,
          },
          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 10,
              centeredSlides: slideCount <= 1
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 15,
              centeredSlides: slideCount <= 2
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 20,
              centeredSlides: slideCount <= 3
            },
            1200: {
              slidesPerView: 4,
              spaceBetween: 20,
              centeredSlides: slideCount <= 4
            }
          },
          on: {
            init: function() {
              solutionsCarouselElement.style.visibility = 'visible';
            }
          }
        });
        
        setTimeout(function() {
          if (solutionsCarouselElement.style.visibility !== 'visible') {
            solutionsCarouselElement.style.visibility = 'visible';
          }
        }, 2000);
        
      } catch (error) {
        solutionsCarouselElement.style.visibility = 'visible';
      }
    }

    const articlesSliderElement = document.querySelector('.articles-slider');
    if (articlesSliderElement) {
      var lastActiveSlide = null;
      
      function animateSlideContent(slide, isEntering) {
        if (!slide) return;
        
        const title      = slide.querySelector('h2');
        const teaserText = slide.querySelector('.field--name-field-teaser-text');
        const readMore   = slide.querySelector('.btn');
        const imageWrap  = slide.querySelector('.field--name-field-image');
        
        if (isEntering) {
          if (title) title.classList.add('slide-content-animate');
          if (teaserText) {
            setTimeout(function() { teaserText.classList.add('slide-content-animate'); }, 80);
          }
          if (readMore) {
            setTimeout(function() { readMore.classList.add('slide-content-animate'); }, 160);
          }
          if (imageWrap) {
            setTimeout(function() { imageWrap.classList.add('slide-content-animate'); }, 240);
          }
        } else {
          if (title) title.classList.remove('slide-content-animate');
          if (teaserText) teaserText.classList.remove('slide-content-animate');
          if (readMore) readMore.classList.remove('slide-content-animate');
          if (imageWrap) imageWrap.classList.remove('slide-content-animate');
        }
      }
      
      function handleActiveSlideChange() {
        var activeSlide = articlesSliderElement.querySelector('.swiper-slide-active');
        if (activeSlide && activeSlide !== lastActiveSlide) {
          if (lastActiveSlide) {
            animateSlideContent(lastActiveSlide, false);
          }
          animateSlideContent(activeSlide, true);
          lastActiveSlide = activeSlide;
        }
      }
      
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            var target = mutation.target;
            if (target.classList.contains('swiper-slide-active')) {
              handleActiveSlideChange();
            }
          }
        });
      });
      
      try {
        const articlesSwiper = new Swiper('.articles-slider', {
          effect: 'slide',
          spaceBetween: 30,
          slidesPerView: 1,
          allowTouchMove: false,
          grabCursor: false,
          loop: true,
          speed: 600,
          cssMode: false,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          },
          scrollbar: {
            el: '.articles-slider .swiper-scrollbar',
            draggable: true,
          },
          on: {
            init: function() {
              articlesSliderElement.classList.add('swiper-initialized');
              
              var wrapper = articlesSliderElement.querySelector('.swiper-wrapper');
              if (wrapper) {
                observer.observe(wrapper, {
                  attributes: true,
                  attributeFilter: ['class'],
                  subtree: true
                });
              }
              
              handleActiveSlideChange();
              
              setTimeout(function() {
                articlesSliderElement.classList.add('swiper-animations-ready');
              }, 50);
            }
          }
        });
        
      } catch (error) {
        articlesSliderElement.classList.add('swiper-initialized');
      }
    }
  }

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeCarousels);
    } else {
      initializeCarousels();
    }
  }
  
  init();
})();
